import { CtaButton } from "@/components/Cta";

const Steps = ({ steps, testId }) => (
  <ol data-testid={testId} className="mt-10 grid gap-6 md:grid-cols-3">
    {steps.map((s, i) => (
      <li key={s.title} data-testid={`${testId}-${i}`} className="nb-card">
        <span className="nb-num text-2xl">{String(i + 1).padStart(2, "0")}</span>
        <h3 className="mt-3 text-base">{s.title}</h3>
        <p className="mt-2 text-sm text-ink2">{s.body}</p>
      </li>
    ))}
  </ol>
);

export const HowItWorksRenters = () => (
  <section data-testid="how-renters" className="nb-section">
    <div className="nb-shell">
      <p className="nb-eyebrow">For renters</p>
      <h2 className="nb-h2 mt-4">Park in three steps</h2>
      <Steps
        testId="renter-steps"
        steps={[
          {
            title: "Tell us where you park",
            body: "Pick your locality and the size of your car (hatchback, sedan or SUV). We show bays whose night hours actually fit your routine.",
          },
          {
            title: "Request the bay you like",
            body: "The host gets your name, phone number and verification status so they can call and check you out. If they accept, you get their number.",
          },
          {
            title: "Pay for the month and park",
            body: "One month minimum. Leave whenever you like with 15 days' notice.",
          },
        ]}
      />
      <p className="mt-6 text-sm text-ink3">
        Payments run through an Indian payment gateway. You get a GST invoice for the platform fee.
      </p>
      <div className="mt-8">
        <CtaButton side="renter" testId="renters-cta">
          Find a spot near me
        </CtaButton>
      </div>
    </div>
  </section>
);

export const HowItWorksHosts = () => (
  <section data-testid="how-hosts" className="nb-section bg-surface2">
    <div className="nb-shell">
      <p className="nb-eyebrow">For hosts</p>
      <h2 className="nb-h2 mt-4">Earn from a bay you already own</h2>
      <Steps
        testId="host-steps"
        steps={[
          {
            title: "List the bay in 5 minutes",
            body: "Photos, night hours, the largest car it fits, and your price. We suggest a price range for your locality so you're not guessing.",
          },
          {
            title: "We verify it",
            body: "A call, a photo check, and for sites with 5 or more bays, a NightBay team member comes and sees it in person. Nothing goes live until that's done.",
          },
          {
            title: "Get paid every month",
            body: "The renter pays for the month, the money settles to your bank account. You keep your full asking price; our ₹300 fee is charged on top to the renter.",
          },
        ]}
      />
      <p className="mt-6 text-sm text-ink3">
        You need a PAN and a bank account in your name to receive payouts. Hosts listing shared or
        common-area bays (RWA, office) also submit a government ID.
      </p>
      <div className="mt-8">
        <CtaButton side="host" testId="hosts-cta">
          I have a bay to rent out
        </CtaButton>
      </div>
    </div>
  </section>
);
